import React, { useState } from 'react'
import { UIProperties } from '../UIProperties';
import CoreGeneralButton from './core-general-button';

import "./core-general-aar-ui.css"
import { UIBaseImplementation } from '../../../UI/UIBaseImplementation';
import { parseDynamicHtml, TextHtmlTagType } from '../../../../misc/tools';
import { constants } from '../../../../misc/constants';
import { GeneralQuestionUIConfigOption } from './core-general-question-ui';

export interface GeneralAARUIBaseImplementation {
	getScore: () => GetScoreResult;
	getPercentage: () => string;
}

class CoreGeneralAARUIBaseImplementation extends UIBaseImplementation {
	public getImplementation(config: GeneralAARUIConfig): GeneralAARUIBaseImplementation {
		let currentScore = 0;
		let maxScore = 0;
		for(var indx = 0; indx < config.entries.length; indx++) {
			var entry = config.entries[indx];
			currentScore += entry.scoreAwarded;
			maxScore += entry.scorePossible;
		}

		const score: GetScoreResult = {
			currentScore: currentScore,
			maxScore: maxScore
		};

		return {
			getScore: (): GetScoreResult => {
				return score;
			},
			getPercentage: (): string => {
				return (((score.currentScore / score.maxScore) * 100).toFixed(0)) + '%';
			}
		}
	}
}

export const coreGeneralAARUIBaseImplementation = new CoreGeneralAARUIBaseImplementation();

const CoreGeneralAARUI = (props: UIProperties<GeneralAARUIConfig>) => {
	const baseImplementation = coreGeneralAARUIBaseImplementation.getImplementation(props.parameters);
	const score = baseImplementation.getScore();
	const percentage = baseImplementation.getPercentage();
	const [isInit, setIsInit] = useState(false);
	const [passed, setIsPassed] = useState(false);
	props.parameters.onGetIfPassed().then((passed: boolean) => {
		setIsPassed(passed);
		setIsInit(true);
	})

	if(!isInit) {
		return null;
	}

	return (
		<div className={`modal-disable-select core-general-aar-ui-container`} style={{
		}}>
			<div className={`core-general-aar-ui-inner-container center-element`} id='aar-content-top' tabIndex={0} aria-label='After Action Review'>
				{!props.parameters.hideAiCoach ? <div style={{
					position: 'absolute',
					left: '20px',
					top: '20px',
					width: '260px',
					height: '60px'
				}}>
					<CoreGeneralButton width= '100%'
						height= '100%'
						idFor508='aar-content-bottom'
						onClick= {props.parameters.onAiCoachClicked}
						onRenderContent= {() => {
							return (
								<p style={{textAlign: 'center', pointerEvents: 'none'}} className='small-text center-element black-text'>Talk to the AI Coach</p>
							)
						}}
						bgColor= {'#D3E1EA'}
						hoverColor={'rgb(159, 191, 211)'}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Talk to the AI Coach'}></CoreGeneralButton>
				</div> : (null)}
				<h1 tabIndex={0} className='core-general-aar-ui-header  center-element'>After Action Review</h1>
				
				{props.parameters.hideScore ? <></> : 
				(<div style={{fontWeight: 'bold'}} className='core-general-aar-ui-score center-element-horizontal'>
					<p tabIndex={0} className=' black-text'>
						{score.currentScore + ' out of ' + score.maxScore + ' (' + percentage + ') - '}
						<span dangerouslySetInnerHTML={{ __html: 
							(passed ? '<span style="color: #1F6E08">Passed</span>' : '<span style="color: #960303">Failed</span>')}}></span></p>
				</div>)}
				<div className='core-general-aar-ui-content center-element-horizontal' style={props.parameters.hideScore ? {
					top: '100px',
					height: '750px'
				}: {}}>
					{props.parameters.entries.map((entry: GeneralAARUISingleEntryConfig, indx: number) => {
						return  (
							<div className='core-general-aar-ui-content-single-element' tabIndex={0}>
								<table>
									<tr>
										<td aria-label={'Question: ' + (indx + 1)} className='aar-scen '><p style={{'color': 'white'}}>{'Question: ' + (indx + 1)}</p></td>
									</tr>
									<tr>
										<td aria-label={'Question'} className='aar-question '><p>Question:</p> </td>
									</tr>
									<tr>
										<td aria-label={entry.questionTitle} className='aar-title '><p>{entry.questionTitle}</p></td>
									</tr>
									<tr>
										<td aria-label={'Is Correct'} className='aar-correct'><p style={{color: entry.isCorrect ? '#1F6E08' : '#960303'}}>{'Is Correct: '}</p></td>
										<td aria-label={(entry.isCorrect ? 'Yes' : 'No')} className='aar-verdict'><p style={{color: entry.isCorrect ? '#1F6E08' : '#960303'}}>{(entry.isCorrect ? 'Yes' : 'No')}</p></td>
									</tr>
									{props.parameters.hideScore ? <></> : 
									(
									<>
										<tr>
											<td aria-label={'Awarded Score'} className='aar-award'>{'Awarded Score: '}</td>
											<td aria-label={entry.scoreAwarded.toString()} className='aar-award-score'>{entry.scoreAwarded}</td>
										</tr>
										<tr>
											<td aria-label={'Possible Score'} className='aar-poss'>{'Possible Score: '}</td>
											<td aria-label={entry.scorePossible.toString()} className='aar-poss-score'>{entry.scorePossible}</td>
										</tr>
									</>)}
									<tr>
										<td aria-label={'Selected Response'} className='aar-correct'><p>{'Selected Response'}</p></td>
										<td className='aar-verdict'>
											{entry.selectedOptions.map((option: GeneralQuestionUIConfigOption, indx: number) => {
												return (<div>
															<p>{option.title + ': ' + option.description}</p>
															{indx < entry.selectedOptions.length - 1 ? <br /> : null}
														</div>)
											})}
										</td>
									</tr>
									<tr>
										<td aria-label={'Feedback'} className='aar-feedback-top'>Feedback:</td>
									</tr>
									<tr>
										<td className='aar-feedback-bot' dangerouslySetInnerHTML={{ __html: parseDynamicHtml("<p><span>"+ entry.feedback +"</span></p>") }}></td>
									</tr>
								</table>
								{/* <p className='default-text' style={{color: 'black', fontWeight: 'bold'}}>{'Scenario: ' + (indx + 1)}</p>
								<br />
								<p className='default-text'>{'Question: ' + entry.questionTitle}</p>
								<br />
								<p className='default-text' style={{color: entry.isCorrect ? '#1F6E08' : '#960303'}}>{'Is Correct: ' + (entry.isCorrect ? 'Yes' : 'No')}</p>
								<br />
								<p className='default-text'>{'Awarded Score: ' + entry.scoreAwarded}</p>
								<br />
								<p className='default-text'>{'Possible Score: ' + entry.scorePossible}</p>
								<br />
								<div dangerouslySetInnerHTML={{ __html: "<p><span class=\"default-text\">Feedback:</span><span>"+ entry.feedback +"</span></p>" }}></div> */}
								

								<hr />
							</div>
						)
					})}
				</div>
				<div className='center-element-horizontal core-general-aar-ui-submit'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						idFor508='aar-content-bottom'
						onClick= {props.parameters.onCloseClicked}
						onRenderContent= {() => {
							return (
								<p style={{pointerEvents: 'none'}}className='small-text center-element black-text'>Close</p>
							)
						}}
						bgColor= {'#D3E1EA'}
						hoverColor={'rgb(159, 191, 211)'}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Close'}></CoreGeneralButton>
				</div>
			</div>
		</div>
	);

};

export interface GeneralAARUIConfig {
	entries: GeneralAARUISingleEntryConfig[];
	onGetIfPassed: () => Promise<boolean>;
	onCloseClicked: () => void;
	onAiCoachClicked: () => void;
	hideAiCoach?: boolean;
	hideScore?: boolean;
}

export interface GeneralAARUISingleEntryConfig {
	questionTitle: string;
	selectedOptions: GeneralQuestionUIConfigOption[];
	feedback: string;
	isCorrect: boolean;
	scoreAwarded: number;
	scorePossible: number;
}

export interface GetScoreResult {
	currentScore: number;
	maxScore: number;
}

export default CoreGeneralAARUI;